import request from '../utils/request';
const querystring = require('querystring')
 
//获取列表数据
export const fetchData = query => {  
    
    var list = request({
        url: 'comTemplate/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
 
//启用-禁用 
export const changeStatus = query => {  
    var list = request({
        url: 'comTemplate/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
//添加渠道信息
export const saveForm = query => {  
    var list = request({
        url: 'comTemplate/insert.do',
        headers: { 'Content-Type':  'multipart/form-data;charset=utf-8' }, 
        method: 'post',
        data: query,  
    }); 
    return list;
};

export const handDelete = query => {  
    var list = request({
        url: 'comTemplate/delete.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const changeForm = query => {  
    var list = request({
        url: 'comTemplate/update.do',
        headers: { 'Content-Type':  'multipart/form-data;charset=utf-8' }, 
        method: 'post',
        data: query,  
    }); 
    return list;
};
 
export const fetchSelect = query => {  
    var list = request({
        url: 'comTemplate/getListFetch.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
//获取文件详情
export const getFilesDetail = query => {  
    var list = request({
        url: 'comTemplate/getFormartFiles.do', 
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
}; 


